// Compute shift duration from start/end date+time.
// Returns null if any field is missing, end <= start, or input is invalid.
// Otherwise returns { totalMinutes, hours, minutes, label }
// label examples: "8h", "8h 30min", "12h 15min"

export function computeShiftDuration(shift) {
  if (!shift) return null;
  const { date, start_time, end_date, end_time } = shift;
  if (!date || !start_time || !end_date || !end_time) return null;
  const start = new Date(`${date}T${start_time}`);
  const end = new Date(`${end_date}T${end_time}`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  const diffMs = end.getTime() - start.getTime();
  if (diffMs <= 0) return null;
  const totalMinutes = Math.round(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const label =
    minutes === 0 ? `${hours}h` : `${hours}h ${String(minutes).padStart(2, "0")}min`;
  return { totalMinutes, hours, minutes, label };
}

// Pretty-print a HH:MM range with optional dates (only show end date if different from start)
export function shiftRangeLabel(shift) {
  if (!shift) return "";
  const { date, start_time, end_date, end_time } = shift;
  if (!start_time || !end_time) return "";
  const sameDay = date && end_date && date === end_date;
  if (sameDay || !end_date) return `${start_time} - ${end_time}`;
  return `${date} ${start_time} - ${end_date} ${end_time}`;
}

// Add minutes to an end time, returning {end_date, end_time}, handling day rollover.
export function addMinutesToShift(startDate, startTime, minutes) {
  if (!startDate || !startTime) return { end_date: "", end_time: "" };
  const start = new Date(`${startDate}T${startTime}`);
  if (Number.isNaN(start.getTime())) return { end_date: "", end_time: "" };
  const end = new Date(start.getTime() + minutes * 60000);
  const yyyy = end.getFullYear();
  const mm = String(end.getMonth() + 1).padStart(2, "0");
  const dd = String(end.getDate()).padStart(2, "0");
  const hh = String(end.getHours()).padStart(2, "0");
  const mi = String(end.getMinutes()).padStart(2, "0");
  return { end_date: `${yyyy}-${mm}-${dd}`, end_time: `${hh}:${mi}` };
}
